<!------------------------------------------------------------------------------
  Copyright (c) 2020. keni

  This file TileCardHorizontal.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  TileCardHorizontal.vue can not be copied and/or distributed
  without the express permission of keni
  ----------------------------------------------------------------------------->

<template>
    <component :is="element_type"
               class="m-0 bg-level-4 d-block"
               data-ref="tile_card_horizontal"

    >
        <div class="row">
            <a data-ref="event_banner" class="col-md-6" :class="getCategory(record)" :href="record.url">
                <div>
                    <div data-ref="event_image" :class="[  {'team-offset':record.event_data.teams.length > 0 }  ]">
                        <div class="upcoming--card--image-wrapper">
                            <team-vs-team
                                    v-if="hasTeams"
                                    :team_a="record.event_data.teams[0]"
                                    :team_b="record.event_data.teams[1]"
                                    cls="upcoming--card-dual-x-wrapper-image d-block mx-auto"
                            />

                            <template v-else>
                                <ImageResponsive
                                        :image="record.images.length > 0?record.images[0]:null"
                                        :alt="lang('title',record.event_data.lang)"
                                        default_size="md"
                                        class="upcoming--card-single-x-wrapper-image d-block mx-auto mb-1"
                                >
                                </ImageResponsive>
                            </template>
                        </div>
                    </div>
                    <!--the text description data-->
                    <div data-ref="event_description" class="text-center pb-1 mt-0 mt-md-2 mb-0 mb-md-1">
                        <stars v-if="typeof record.counted !== 'undefined' && record.counted !== null"
                               class="text-info"
                               :value="readWeight(record)"
                        />
                        <h4 class="tile-card--title card-title"
                            :class="{
                'mt-3':!(typeof record.counted !== 'undefined' && record.counted !== null)
                }">
                            <bold-words data-ref="event_title"
                                        :word="{
                            text:lang('title',record.event_data.lang)
                        }"/>
                        </h4>
                        <!--                    Event description-->
                        <div class="tile-card--body text-body">
                            <div>
                                <div data-ref="event_date"
                                     v-if="record.start_date !== null"
                                     class="tile-card--date-block mb-2"
                                >
                                    {{getDateString(record.start_date,'month')}}{{getDateString(record.start_date,'day')}}
                                    <template v-if="record.end_date !== null && start_day !== end_day">
                                        <span>-</span>
                                        {{getDateString(record.end_date,'month')}}{{getDateString(record.end_date,'day')}}
                                    </template>
                                    <template v-else>
                                        <span>@</span> {{getDateString(record.start_date,'time')}}
                                    </template>
                                </div>
                                <bold-words
                                        v-else
                                        element_type="div"
                                        class="tile-card--date-block text-uppercase mb-2"
                                        :word="{
                        text:'Date to be advised'
                        }"
                                />
                                <!--Description-->
                                <h4 class="card-text tile-card--description"
                                    v-html="lang('description.short',record.event_data.lang)"/>
                                <div class="card-text tile-card--description"
                                     v-html="lang('description.long',record.event_data.lang)"/>
                            </div>
                            <div class="btn btn-primary align-self-end">More...</div>
                        </div>
                    </div>
                </div>
            </a>
            <div data-ref="event_tickets" class="col-md-6">
                <div v-if="tickets!==null"
                     class="px-3 pt-0 pb-3 tile-card--tickets"
                >
                    <AddonTicketModal
                            :id="`event-addons--${record.id}`"
                            :tickets="addons"
                            :price_formatted="true"
                            :lang_formatted="true"
                            :add_ticket_url="add_ticket_url"
                            :display="display_modal"
                            @modal_close="modalClosed"
                    >
                    </AddonTicketModal>
                    <tileCardTicket v-for="(ticket,index) in limitedTickets"
                                    :tickets_len="ticketsLength"
                                    :tickets_limit="tickets_limit"
                                    :first="index <= 0"
                                    class="text-left"
                                    :key="ticket.id"
                                    :ticket="ticket"
                                    :index="index"
                                    @toggle="toggleTicket"
                                    @ticket_clicked="ticketClicked"
                    />
                    <div class="row" v-if="ticketsCapped">
                        <div class="col text-center">
                            <a class="btn btn-primary align-self-end" :href="record.url">More Available...</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--show line in small view-->
        <hr class="d-block d-md-none my-0">
    </component>
</template>

<script>
    window.Vue.component('tileCardTicket', require('./tileCardTicket'));
    window.Vue.component('AddonTicketModal', require('../../tickets/AddonTicketModal'));
    window.Vue.component('ImageResponsive', require('../../images/ImageResponsive.vue'));
    //
    import {$basketController} from '../../../config/config.js';

    import {_} from 'underscore';
    import {percentageSplit} from '../../../../../../app/Shared/Resources/Assets/js/helpers/calc';
    import {readImageFromData, createMainImage} from '../../../../../../app/Shared/Resources/Assets/js/helpers/images';
    import lang from '../../../../../../app/Shared/Resources/Assets/js/helpers/lang'
    import {HUB, CDN_URL, BUCKET_NAME, IMAGE_URL_BASE} from '../../../config/config';
    import {
        getDate,
        getTime,
        setDate,
        getYear,
        getMonth,
        getDay
    } from '../../../../../../app/Shared/Resources/Assets/js/helpers/format.date';
    import BasketTickets from '../../basket/BasketTickets.js';

    window.Vue.component('bold-words', require('../../../../../../app/Shared/Resources/Assets/js/components/BoldWords'));
    window.Vue.component('stars', require('./stars'));
    export default {
        name: "TileCardHorizontal",
        props: {
            id: {
                type: String,
            },
            add_ticket_url: {
                type: String,
                default: null
            },
            /**
             * @param {Object} record.event_data.teams
             * @param {Object} record.event_data
             * @param {String} record.start_date
             * @param {String} record.end_date
             * @param {Object} record
             */
            record: Object,
            records: Array,
            tickets: {
                type: Array,
                default: null
            },
            element_type: {
                type: String,
                default: 'a'
            },
            category_type: {
                type: String
            },
            tickets_limit: {
                type: Number,
                default: 6
            }
        },
        mounted() {
            let self = this;

            if (self.record.start_date !== null && ('end_date' in self.record && self.record.end_date !== null)) {
                self.start_day = getDay(self.record.start_date);
                self.end_day = getDay(self.record.end_date);
            }
            self.sortTickets();
            $basketController
                .$on('read_basket', function (ticket_id) {
                    // console.log('elm',elm)
                    // console.log(self.tickets);

                    // is the id in the list?
                    for (let i = 0; i < self.tickets.length; i++) {
                        let ticket = self.tickets[i];

                        // console.log(ticket, ticket.id, ticket_id, ticket.id === ticket_id);
                        if (ticket.ticket_type !== 'addon' && ticket.id === ticket_id) {
                            self.display_modal = true;
                            break;
                        }
                    }
                });
        },
        data() {
            return {
                addons: [],
                display_modal: false,
                greeting: 'Hello',
                start_day: '',
                end_day: '',
                tickets_compiled: [],
            }
        },
        watch: {
            addons(){
                this.$emit('addons_updated',this.addons);
            },
            tickets() {
                this.sortTickets();
            }
        },
        mixins: ['BasketTickets'],
        methods: {
            modalClosed() {
                this.display_modal = false;
            },
            toggleTicket(index) {
                let self = this;
                self.tickets_compiled[index].show = !self.tickets_compiled[index].show;
            },
            sortTickets() {
                let self = this;

                if (self.tickets !== null) {

                    for (let i = 0; i < self.tickets.length; i++) {
                        let ticket = self.tickets[i];

                        ticket['show'] = false;
                        // sort addon tickets
                        if (self.tickets[i].ticket_type === 'addon') {
                            self.addons.push(self.tickets[i]);
                        }
                        self.tickets_compiled.push(ticket);
                    }
                }
            },
            getDay(date) {
                return getDay(date);
                // return new Date(date).setHours(0, 0, 0, 0) / 1000;
            },
            ticketClicked(id) {
                this.$emit('ticket_clicked', id)
            },
            getCategory(record) {

                if (typeof record.category_slug !== 'undefined' && record.category_slug !== null) {
                    return 'bg-category-' + record.category_slug
                } else if (typeof record.category.slug !== 'undefined' && record.category.slug !== null) {
                    return 'bg-category-' + record.category.slug
                } else if (this.category_type !== null) {
                    return 'bg-category-' + this.category_type
                } else {
                    return 'ticket';
                }

            },
            log() {
                console.log.apply(console, arguments);
            },
            lang(path, object) {
                // console.log('object',object);
                // return;
                return lang(path, object);
            },
            readDefaultImage() {
                return IMAGE_URL_BASE.default_image_url;
            },
            createImageUrl(record) {
                // let imageModel = readImageFromData(record);
                let imageModel = createMainImage(record);

                // console.log('createImageUrl', 'record',record);
                if (typeof imageModel !== 'undefined' && imageModel !== null) {
                    return `${imageModel}`
                }

            },
            getDateString(date, type) {
                switch (type) {
                    case 'year':
                        return getYear(date, true);
                    case 'month':
                        return getMonth(date, 'name_short');
                    case 'day':
                        return getDay(date, 'num_short');
                    case 'time':
                        return getTime(date);
                    default:
                        console.error('no date defined', date);

                }
            },
            readWeight(record) {
                // console.log('record', record);
                if (typeof record.counted !== 'undefined' && record.counted !== null) {
                    return percentageSplit(this.records, record, 'counted');
                }
            },
        },
        computed: {
            hasTeams() {
                return this.record.event_data.teams.length > 0
            },

            ticketsLength() {
                return this.tickets_compiled.length;
            },
            ticketsCapped(){
                let self = this;

                return self.tickets_compiled.length > self.tickets_limit;
            },
            limitedTickets() {
                let self = this;

                if (self.tickets_compiled.length > self.tickets_limit) {
                    return self.tickets_compiled.slice(0, self.tickets_limit);
                } else {
                    return self.tickets_compiled;
                }
            }
        }
    }
</script>

<style scoped="">
    /*.card-text {*/
    /*    min-height: 80px;*/
    /*}*/

    p {
        font-size: 2em;
        text-align: center;
    }

    .category-icon {
        right: 0;
        top: 0;
        opacity: 0.1;
        font-size: 20em;
    }

    .team-offset {
        /*margin-top: 25px;*/
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/front/modules/TileCardHorizontal.vue